export default "__VITE_ASSET__141a657c__"